import hdrm from '../../hdrm';
import site from '../../site';
import globals from '../../globals';

import actionTypes from '../constants/action-types';
import { UPDATE_LIVE_ONLY } from '../../hdrm/constants/update-strategies';

const handleSetAttributeAction = (action) => {
  const { elementId, attr, value, options } = action.payload;
  const { strategy } = options;

  return hdrm.operations.setElementAttribute(elementId, attr, value, strategy);
};

const setElementAttribute = (store) => (next) => (action) => {
  switch (action.type) {
    case actionTypes.BULK_VIEW_ACTIONS: {
      const actions = action.payload.actions.filter(
        (targetAction) => targetAction.type === actionTypes.SET_ELEMENT_ATTRIBUTE
      );

      actions.forEach((targetAction) => {
        handleSetAttributeAction(targetAction);
      });

      next(action);

      break;
    }
    case actionTypes.SET_ELEMENT_ATTRIBUTE: {
      const { globalsToUpdate, options } = action.payload;
      const { strategy } = options;

      const newHTML = handleSetAttributeAction(action);

      if (strategy !== UPDATE_LIVE_ONLY) {
        const state = store.getState();
        const pageId = site.selectors.getActivePageId(state);

        globals.helpers.saveGlobals(globalsToUpdate);
        store.dispatch(site.actions.setPageHTML(pageId, newHTML));
      }

      next(action);

      break;
    }
    default:
      next(action);
  }
};

export default setElementAttribute;
